import QueryKeyFactory from "../../../api/hooks/utils/queryKeyFactory";

export const customerKeys = new QueryKeyFactory('customer')
